import { render, staticRenderFns } from "./PackageUpdateLinkedModal.vue?vue&type=template&id=23f6aa77&"
import script from "./PackageUpdateLinkedModal.vue?vue&type=script&lang=js&"
export * from "./PackageUpdateLinkedModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports